import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import DashboardBase from '../../components/DashboardBase/DashboardBase';
import baseServerUrl from '../../services/apiServer';

const PrivateRoute = ({ isDashboardBase }) => {
  const { currentUser } = useSelector((state) => state.authReducer);
  if (!currentUser) {
    window.location.href = `${baseServerUrl}/login`;
    return null;
  }

  if (isDashboardBase) {
    return (
      <DashboardBase>
        <Outlet />
      </DashboardBase>
    );
  }
  return <Outlet />;
};

export default PrivateRoute;
